import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetobhimashankarminibushire() {



  const cardData = {
"keyword": "Pune to Bhimashankar Mini Bus Hire in Pune",

"headingDescription":
  "Aaradhya Travels offers reliable Pune to Bhimashankar Mini Bus Hire in Pune for group pilgrimage travel, family tours, corporate outings, school trips, and weekend religious journeys. Our well-maintained mini buses are available in AC and Non-AC options with comfortable pushback seating, ample luggage space, and experienced drivers familiar with ghat road routes. We ensure safe, smooth, and timely travel from Pune to Bhimashankar Jyotirlinga with flexible booking options and affordable group packages.",

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description":
      "Bhimashankar Jyotirlinga Temple is one of the 12 sacred Jyotirlingas of Lord Shiva located in the Sahyadri hills. It is the main pilgrimage destination for devotees traveling from Pune and is surrounded by dense forests and peaceful natural scenery."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description":
      "Bhimashankar Wildlife Sanctuary is a protected forest area known for rich biodiversity, rare flora and fauna, and the habitat of the Indian Giant Squirrel. It is a key attraction for nature lovers visiting the region."
  },
  {
    "title": "Gupt Bhimashankar",
    "description":
      "Gupt Bhimashankar is a hidden sacred spot near the main temple believed to be the original origin point of the Shivlinga. It is a peaceful spiritual site often visited by pilgrims after darshan."
  },
  {
    "title": "Hanuman Lake",
    "description":
      "Hanuman Lake is a calm natural water body near Bhimashankar surrounded by forest landscapes. It is a scenic stop for pilgrims and group travelers on temple trips."
  },
  {
    "title": "Nag Phani Point",
    "description":
      "Nag Phani Point is a viewpoint near Bhimashankar offering panoramic views of the Sahyadri mountains and deep valleys, popular among group travelers and nature enthusiasts."
  },
  {
    "title": "Sahyadri Ghat Route",
    "description":
      "The Pune to Bhimashankar route passes through scenic Sahyadri ghat roads with dense greenery, winding turns, and rural landscapes, making the journey both spiritual and adventurous."
  },
  {
    "title": "Rajgurunagar",
    "description":
      "Rajgurunagar is a major halt point on the way from Pune to Bhimashankar known for food stops, fuel stations, and rest breaks for group travelers."
  },
  {
    "title": "Manchar Route Scenic Drive",
    "description":
      "The Manchar route to Bhimashankar is a popular highway stretch followed by ghat roads, widely used by mini buses for smoother and safer group travel."
  },
  {
    "title": "Khed Ghat Section",
    "description":
      "Khed Ghat section is a winding mountainous stretch en route to Bhimashankar known for sharp curves and scenic valley views, requiring experienced drivers for safe travel."
  },
  {
    "title": "Shivneri Fort (Nearby Attraction)",
    "description":
      "Shivneri Fort, located near the Bhimashankar route region, is the birthplace of Chhatrapati Shivaji Maharaj and a popular historical stop for group tours from Pune."
  }
],



services: [
  {
    name: "Pune to Bhimashankar Jyotirlinga Tempo Traveller",
    description: "Pune to Bhimashankar Jyotirlinga Tempo Traveller service provides comfortable transportation for devotees visiting the sacred Bhimashankar Jyotirlinga temple from Pune. Spacious seating and smooth ghat road travel ensure pleasant pilgrimage journeys suitable for families, senior citizens, and spiritual groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Bhimashankar traveller reservations."
  },
  {
    name: "Pune to Bhimashankar 17 Seater Mini Bus on Rent",
    description: "Pune to Bhimashankar 17 seater mini bus on rent service offers spacious transportation for family pilgrimage tours, temple darshan trips, sightseeing journeys, and group travel from Pune. Comfortable seating and luggage capacity ensure smooth highway and ghat road travel suitable for medium-sized passenger groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 17 seater bus reservations."
  },
  {
    name: "Pune to Bhimashankar Mini Bus on Rent",
    description: "Pune to Bhimashankar mini bus on rent service provides reliable transportation for spiritual journeys, family vacations, educational tours, and pilgrimage travel from Pune. Spacious interiors and comfortable seating ensure pleasant travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the Bhimashankar route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient mini bus reservations."
  },
  {
    name: "Pune to Jyotirlinga Bhimashankar Mini Bus on Rent",
    description: "Pune to Jyotirlinga Bhimashankar mini bus on rent service offers comfortable transportation for devotees visiting the sacred Jyotirlinga temple and nearby pilgrimage destinations from Pune. Spacious seating and smooth travel performance ensure pleasant journeys suitable for spiritual groups and family darshan tours. Professional drivers ensure safe transportation and reliable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotirlinga mini bus reservations."
  },
  {
    name: "Pune to Bhimashankar Round Trip Bus on Rent",
    description: "Pune to Bhimashankar round trip bus on rent service provides dependable two-way transportation for temple visits, sightseeing tours, family travel, and group journeys from Pune. Spacious buses ensure comfortable seating and smooth highway travel suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services for both onward and return journeys. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient round trip bus reservations."
  },
  {
    name: "Pune to 5 Jyotirlinga Darshan Mini Bus on Rent",
    description: "Pune to 5 Jyotirlinga Darshan mini bus on rent service offers premium transportation for devotees visiting sacred Jyotirlinga temples across Maharashtra and nearby regions. Spacious seating and luggage space ensure comfortable long-distance pilgrimage journeys suitable for families and spiritual groups. Professional drivers ensure safe transportation and dependable pickup services throughout the temple circuit route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient Jyotirlinga mini bus reservations."
  },
  {
    name: "Pune to Bhimashankar AC Mini Bus on Rent",
    description: "Pune to Bhimashankar AC mini bus on rent service provides premium air-conditioned transportation for pilgrimage tours, sightseeing journeys, family vacations, and tourist travel from Pune. Comfortable seating and cooling systems ensure pleasant travel experiences suitable for all weather conditions. Professional chauffeurs ensure safe driving and reliable transportation services throughout the Bhimashankar route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient AC mini bus reservations."
  },
  {
    name: "Pune to Bhimashankar Luxury Bus Hire",
    description: "Pune to Bhimashankar luxury bus hire service offers spacious premium transportation for temple darshan tours, group travel, family outings, and pilgrimage journeys from Pune. Luxury seating and modern interiors ensure smooth travel experiences suitable for devotees and tourist groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient luxury bus reservations."
  },
  {
    name: "Pune to Bhimashankar Group Tour Bus",
    description: "Pune to Bhimashankar group tour bus service provides comfortable transportation for tourist groups, spiritual journeys, educational tours, and sightseeing travel from Pune. Spacious seating and smooth highway performance ensure pleasant travel experiences suitable for medium and large passenger groups. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient group tour bus reservations."
  },
  {
    name: "Pune to Bhimashankar Pilgrimage Tour Bus",
    description: "Pune to Bhimashankar pilgrimage tour bus service offers reliable transportation for temple darshan tours, spiritual journeys, and religious group travel from Pune. Spacious buses and comfortable seating ensure smooth pilgrimage travel suitable for devotees, families, and senior citizens. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient pilgrimage bus reservations."
  },
  {
    name: "Pune to Bhimashankar Private Bus Booking",
    description: "Pune to Bhimashankar private bus booking service provides exclusive transportation for family trips, temple tours, wedding groups, and sightseeing journeys from Pune. Spacious buses and private travel comfort ensure smooth and personalized travel experiences suitable for all passenger groups. Professional chauffeurs ensure safe driving and punctual pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient private bus reservations."
  },
  {
    name: "Pune to Bhimashankar Wedding Group Transport",
    description: "Pune to Bhimashankar wedding group transport service offers comfortable transportation for wedding guests, family members, bridal parties, and marriage event travel requirements. Spacious buses ensure smooth travel experiences suitable for large family gatherings and wedding functions. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, banquet halls, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient wedding group transport reservations."
  },
  {
    name: "Pune to Bhimashankar Corporate Trip Bus",
    description: "Pune to Bhimashankar corporate trip bus service provides professional transportation for office outings, employee trips, team-building activities, and corporate travel requirements from Pune. Spacious seating and comfortable interiors ensure pleasant journeys suitable for business teams and office groups. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from IT parks, offices, hotels, airports, and commercial locations across Pune. Flexible booking options allow convenient corporate bus reservations."
  },
  {
    name: "Pune to Bhimashankar School Trip Bus",
    description: "Pune to Bhimashankar school trip bus service offers safe and spacious transportation for educational tours, student outings, nature trips, and school travel requirements from Pune. Comfortable seating and smooth highway performance ensure pleasant journeys suitable for students, teachers, and educational groups. Professional drivers ensure safe transportation and punctual pickup services throughout the route. Pickup services are available from schools, colleges, coaching institutes, homes, and educational campuses across Pune. Flexible booking options allow convenient school trip bus reservations."
  },
  {
    name: "Pune to Bhimashankar Family Trip Bus",
    description: "Pune to Bhimashankar family trip bus service provides dependable transportation for holiday outings, temple visits, sightseeing journeys, and group travel with relatives and family members. Spacious interiors and comfortable seating ensure smooth travel experiences suitable for local and outstation family trips. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, railway stations, airports, and residential areas across Pune. Flexible booking options allow convenient family trip bus reservations."
  },
  {
    name: "Pune to Bhimashankar Outstation Bus Hire",
    description: "Pune to Bhimashankar outstation bus hire service offers premium transportation for pilgrimage journeys, sightseeing tours, educational travel, and tourist group trips from Pune. Spacious buses and luggage capacity ensure comfortable long-distance travel suitable for all passenger groups. Professional drivers ensure safe transportation and dependable pickup services throughout the route. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient outstation bus reservations."
  }
],

tableData: [
  ["Pune to Bhimashankar Jyotirlinga Tempo Traveller", "Pune to Bhimashankar 17 Seater Mini Bus on Rent"],
  ["Pune to Bhimashankar Mini Bus on Rent", "Pune to Jyotirlinga Bhimashankar Mini Bus on Rent"],
  ["Pune to Bhimashankar Round Trip Bus on Rent", "Pune to 5 Jyotirlinga Darshan Mini Bus on Rent"],
  ["Pune to Bhimashankar AC Mini Bus on Rent", "Pune to Bhimashankar Luxury Bus Hire"],
  ["Pune to Bhimashankar Group Tour Bus", "Pune to Bhimashankar Pilgrimage Tour Bus"],
  ["Pune to Bhimashankar Private Bus Booking", "Pune to Bhimashankar Wedding Group Transport"],
  ["Pune to Bhimashankar Corporate Trip Bus", "Pune to Bhimashankar School Trip Bus"],
  ["Pune to Bhimashankar Family Trip Bus", "Pune to Bhimashankar Outstation Bus Hire"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Bhimashankar Mini Bus Hire in Pune",
        WhyChoosedescription: "Aaradhya Travels provides reliable Pune to Bhimashankar mini bus hire service with comfortable vehicles, professional drivers, and smooth travel arrangements for pilgrimage tours and group travel."
      },
      {
        WhyChooseheading: "Affordable Bhimashankar Mini Bus Packages",
        WhyChoosedescription: "Aaradhya Travels offers affordable Pune to Bhimashankar mini bus hire packages with transparent pricing, flexible travel plans, and complete booking assistance without hidden charges."
      },
      {
        WhyChooseheading: "24/7 Mini Bus Booking Service",
        WhyChoosedescription: "Our Pune to Bhimashankar mini bus hire service operates 24 hours for family pilgrimage tours, Jyotirlinga darshan trips, corporate outings, and weekend group travel."
      },
      {
        WhyChooseheading: "Comfortable & Spacious Mini Buses",
        WhyChoosedescription: "All mini buses provided by Aaradhya Travels are spacious, clean, regularly maintained, and available in AC and Non-AC options for comfortable temple travel experiences."
      },
      {
        WhyChooseheading: "One Day & Multi-Day Bhimashankar Tours",
        WhyChoosedescription: "Aaradhya Travels offers one-day Bhimashankar darshan trips, weekend pilgrimage journeys, multi-day temple tours, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Ideal for Family & Group Pilgrimage Travel",
        WhyChoosedescription: "Mini buses are ideal for family tours, senior citizen darshan travel, tourist groups, office teams, and comfortable group journeys to Bhimashankar Temple."
      },
      {
        WhyChooseheading: "Pickup Available Across Pune City",
        WhyChoosedescription: "Aaradhya Travels provides doorstep pickup from homes, hotels, Pune Airport, railway stations, and major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Ghat & Temple Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Bhimashankar ghat roads and temple routes, ensuring safe driving, smooth travel, and timely darshan for every pilgrimage journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Bhimashankar mini bus hire service?", answer: "Pune to Bhimashankar mini bus hire service provides comfortable group transportation for Bhimashankar Jyotirlinga darshan, family tours, and pilgrimage travel." },
    { question: "Is mini bus booking available 24 hours for Bhimashankar travel?", answer: "Yes, Aaradhya Travels provides 24/7 mini bus hire service from Pune to Bhimashankar." },
    { question: "Can I book mini bus for one-day Bhimashankar trip?", answer: "Yes, customers can book one-day as well as multi-day Bhimashankar mini bus tour packages." },
    { question: "Do you provide customized Bhimashankar travel packages?", answer: "Yes, Aaradhya Travels provides customized pilgrimage and temple travel packages according to customer requirements." },
    { question: "Are AC and Non-AC mini buses available?", answer: "Yes, Aaradhya Travels provides both AC and Non-AC mini buses for comfortable and budget-friendly group travel." },
    { question: "Can I book Pune to Bhimashankar mini bus online?", answer: "Yes, customers can easily book mini bus hire service online or through phone booking." },
    { question: "Do you provide mini buses for family and group pilgrimage tours?", answer: "Yes, Aaradhya Travels provides spacious mini buses suitable for families, senior citizens, and group darshan travel." },
    { question: "Are Pune to Bhimashankar mini bus hire charges transparent?", answer: "Yes, Aaradhya Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Bhimashankar mini bus hire?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and festive pilgrimage seasons." },
    { question: "Do you provide pickup from Pune Airport and railway stations?", answer: "Yes, Aaradhya Travels provides pickup and drop services from Pune Airport, railway stations, hotels, and all major Pune locations." }
  ];

const testimonials = [
  {
    id: 1,
    name: "Mr. Sandeep Kulkarni",
    feedback:
      "The Pune to Bhimashankar trip arranged by Aaradhya Travels in a mini bus was very well planned. The vehicle handled the ghat roads comfortably, and the group travel felt safe and relaxed throughout.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Aarti Joshi",
    feedback:
      "Aaradhya Travels made our Pune to Bhimashankar journey smooth with a well-maintained mini bus. The travel experience was steady even on hilly routes, and everyone enjoyed the trip without any discomfort.",
    rating: 5
  }
];



  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "Tempo-Traveller-On-Rent-in-Pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Mahabaleshwar Tempo Traveller", link: "Pune-to-Mahabaleshwar-Tempo-Traveller" },
    { place: "/images/keyword/3.jpg", text: "Pune to Outstation Tempo Traveller", link: "Pune-to-Outstation-Tempo-Traveller" },
    { place: "/images/keyword/4.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Mini Bus on Rent Pune", link: "Outstation-Mini-Bus-on-Rent-Pune" },
    { place: "/images/keyword/6.jpg", text: "14 Seater Tempo Traveller on Rent in Pune", link: "14-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "17 Seater Bus on Rent in Pune", link: "17-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Tempo Traveller", link: "Pune-to-Shirdi-Tempo-Traveller" },
    { place: "/images/keyword/9.jpg", text: "20 Seater Bus on Rent in Pune", link: "20-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/10.jpg", text: "25 Seater Tempo Traveller on Rent in Pune", link: "25-Seater-Tempo-Traveller-on-Rent-in-Pune" },
    { place: "/images/keyword/11.jpg", text: "Tempo Traveller on Rent in Pimpri Chinchwad", link: "Tempo-Traveller-on-Rent-in-Pimpri-Chinchwad" },
    { place: "/images/keyword/12.jpg", text: "32 Seater Bus Rent in Pune", link: "32-Seater-Bus-Rent-in-Pune" },
    { place: "/images/keyword/13.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/14.jpg", text: "45 Seater Bus on Rent in Pune", link: "45-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/15.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-Seater-Bus-On-Rent-in-Pune" },
    { place: "/images/keyword/16.jpg", text: "Non AC Bus Rental Service in Pune", link: "Non-AC-Bus-Rental-Service-in-Pune" },
    { place: "/images/keyword/17.jpg", text: "Luxury Bus Rental in Pune", link: "Luxury-Bus-Rental-in-Pune" },
    { place: "/images/keyword/18.jpg", text: "Luxury Force Urbania On Rent in Pune", link: "Luxury-Force-Urbania-On-Rent-in-Pune" },
    { place: "/images/keyword/19.jpg", text: "Force Urbania Luxury Mini Bus On Rent", link: "Force-Urbania-Luxury-Mini-Bus-On-Rent" },
    { place: "/images/keyword/20.jpg", text: "Mini Bus On Rent in Pune", link: "Mini-Bus-On-Rent-in-Pune-2" },
    { place: "/images/keyword/21.jpg", text: "14 17 20 25 Seater Bus on Rent in Pune", link: "14-17-20-25-Seater-Bus-on-Rent-in-Pune" },
    { place: "/images/keyword/22.jpg", text: "Travel Agents in Pune for Mini Bus Hire", link: "Travel-Agents-in-Pune-for-Mini-Bus-Hire" },
    { place: "/images/keyword/23.jpg", text: "Tempo Traveller Hire in Pune", link: "Tempo-Traveller-Hire-in-Pune" },
  ];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Bhimashankar Jyotirlinga Mini Bus Hire",
  "image": "https://www.aaradhyatravels99.com/assets/images/pune-to-bhimashankar-mini-bus.jpg",
  "description": "Book Pune to Bhimashankar Jyotirlinga Mini Bus Hire with Aaradhya Travels for pilgrimage trips, family tours, and group travel. Affordable 17 seater mini bus and tempo traveller available for Bhimashankar, Jyotirlinga darshan, and Maharashtra temple tours.",
  "brand": {
    "@type": "Brand",
    "name": "Aaradhya Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2633"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "On Request",
    "availability": "https://schema.org/InStock",
    "url": "https://www.aaradhyatravels99.com/pune-to-bhimashankar-jyotirlinga-mini-bus-hire"
  }
};




  return (
    <div>
<Helmet>
  <title>
    Pune to Bhimashankar Jyotirlinga Mini Bus Hire | Pilgrimage Travel | +91 9529697070
  </title>

  <meta
    name="description"
    content="Hire Pune to Bhimashankar Jyotirlinga Mini Bus with Aaradhya Travels. Affordable 17 seater mini bus and tempo traveller available for Bhimashankar temple trips, Jyotirlinga darshan, round trips, and group pilgrimage travel from Pune."
  />

  <meta
    name="keywords"
    content="Pune to Bhimashankar Jyotirlinga Tempo Traveller, Pune to Bhimashankar 17 Seater Mini Bus on Rent, Pune to Bhimashankar Mini Bus on Rent, Pune to Jyotirlinga Bhimashankar Mini Bus on Rent, Pune to Bhimashankar round trip bus on rent, Pune to 5 Jyotirlinga Darshan Mini Bus on Rent, Pune to Bhimashankar AC Mini"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1
                  className="text-anime-style-3 text-center text-white"
                  data-cursor="-opaque"
                >
                  {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#FFB100', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Aaradhya Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaradhya Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaradhya Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


               <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529697070" className="pc-call">+91 9529697070</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529697070"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529697070" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@aaradhyatravels99.com" className="pc-email">
                      booking@aaradhyatravels99.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aaradhya Travels</strong><br />
                      Near RMD College, Opp. Chaudhary Parking, Warje, Pune - 411058
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetobhimashankarminibushire;